import { render } from "./InteractiveElement.vue?vue&type=template&id=6f383896"
import script from "./InteractiveElement.vue?vue&type=script&lang=js"
export * from "./InteractiveElement.vue?vue&type=script&lang=js"
script.render = render

export default script